import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { validateLogin, fetchWhoami, signOut } from "store/slices/authSlice";
import { scheduleTokenRefresh } from "../../utils/tokenWatcher";

function AuthWrapper({ children }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading, isAuthenticated, userData, expiresAt } = useSelector(
    (state) => state.auth
  );

  const [showDeactivatedModal, setShowDeactivatedModal] = useState(false);

  // Initial login validation
  useEffect(() => {
    dispatch(validateLogin());
  }, [dispatch]);

  // Schedule token refresh ONLY after expiresAt is available
  useEffect(() => {
    if (expiresAt) {
      scheduleTokenRefresh();
    }
  }, [expiresAt]);

  // Fetch whoami
  useEffect(() => {
    if (isAuthenticated && !userData) {
      dispatch(fetchWhoami());
    }
  }, [dispatch, isAuthenticated, userData]);

  // Check if organisation is deactivated
  useEffect(() => {
    if (userData?.organisations?.length > 0) {
      const organisation = userData.organisations[0];
      if (organisation.is_active === false) {
        setShowDeactivatedModal(true);
      }
    }
  }, [userData]);

  // Handle logout when organisation is deactivated
  const handleDeactivatedLogout = () => {
    setShowDeactivatedModal(false);
    dispatch(signOut());
  };

  if (loading) {
    return null;
  }

  return (
    <>
      {children}
      <Modal
        title={t("auth.deactivated.title")}
        open={showDeactivatedModal}
        onOk={handleDeactivatedLogout}
        okText={t("auth.deactivated.okButton")}
        okButtonProps={{ danger: true }}
        cancelButtonProps={{ style: { display: "none" } }}
        closable={false}
        maskClosable={false}
      >
        <p>{t("auth.deactivated.message")}</p>
      </Modal>
    </>
  );
}

export default AuthWrapper;
